var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7498)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6918 17.9725C23.3655 16.2987 25.6357 15.3584 28.0027 15.3584C30.3698 15.3584 32.6399 16.2987 34.3137 17.9725C35.9875 19.6463 36.9279 21.9164 36.9279 24.2835V32.2522C36.9279 32.8106 37.1496 33.3462 37.5445 33.7411C37.9925 34.1891 38.3446 34.3577 38.8371 34.3577C39.3356 34.3577 39.7399 34.7618 39.7399 35.2606C39.7399 35.7591 39.3356 36.1634 38.8371 36.1634H17.1685C16.6698 36.1634 16.2656 35.7591 16.2656 35.2606C16.2656 34.7618 16.6698 34.3577 17.1685 34.3577C17.6609 34.3577 18.0129 34.1891 18.461 33.7411C18.8558 33.3462 19.0777 32.8106 19.0777 32.2522V24.2835C19.0777 21.9164 20.018 19.6463 21.6918 17.9725ZM24.8428 39.2859C24.8428 38.538 25.4491 37.9316 26.1971 37.9316H29.8085C30.5564 37.9316 31.1628 38.538 31.1628 39.2859C31.1628 40.0338 30.5564 40.6402 29.8085 40.6402H26.1971C25.4491 40.6402 24.8428 40.0338 24.8428 39.2859Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7498",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f09f0c969ce7ff30ca8a32e61281a857.svg";
export { ForwardRef as ReactComponent };